export default function helloWorld() {

  console.log('%cBGN\n' + '%cBuilt by BGN Agency:\n' + '%chttps://www.bgn.agency/', 'font-family: Georgia;font-size: 3em;font-weight: bold;color: #f8bdd7;', 'font-size: 1em;color: #f8bdd7;', 'font-size: 1em;');

}